module.exports = __webpack_public_path__ + "img/pink-car.e491c1eb.png";